<template lang="html">
  <v-container fluid style="position: absolute">
    <InfoBox
        v-if="show_info_box"
        @clickOutside="closeInfoBox()"
        >
        <template #button-top>
          <WaggonInfoNavButton
            v-if="showUp()"
            direction="up"
            width="80px"
            @click.native="routeUp()"
            />
        </template>
        <template #button-right>
          <WaggonInfoNavButton
            v-if="showRight()"
            direction="right"
            height="80px"
            @click.native="routeRight()"
            />
        </template>
        <template #button-bottom>
          <WaggonInfoNavButton
            v-if="showDown()"
            direction="down"
            width="80px"
            @click.native="routeDown()"
            />
        </template>
        <template #button-left>
          <WaggonInfoNavButton
            v-if="showLeft()"
            direction="left"
            height="80px"
            @click.native="routeLeft()"
            />
        </template>
        <template #default>
        <WaggonInfo
          :waggon="{}"
          >
          <template #header>
            <WaggonInfoHeader
              v-for="(work_package) in work_packages_large"
              :key="'header' + work_package.id"
              :width="'100%'"
              :color="work_package.color"
              :text="work_package.token"
              :icon="work_package.icon"
              />
          </template>
          <template #body>
            <template v-if="show_info_box_body === 'info'">
              <WaggonInfoBody
                :color="work_packages_large[work_packages_large_index].color"
                :work_package="work_packages_large[work_packages_large_index]"
                :info_box="true"
                >
                <template #body-content="body_slot">
                  <StandardDataField
                    :value="body_slot.work_package.name"
                    readonly="true"
                    />
                  <StandardDataField
                    :value="body_slot.work_package.description"
                    flat="true"
                    placeholder="description"
                    :resizable="true"
                    :readonly="true"
                    />
                  <v-divider color="black"></v-divider>
                    <StandardFlexBox>
                      <!-- attributes planned -->
                      <StandardFlexBox
                        class="pa-1"
                        width="50%"
                        direction="column"
                        >
                        attributes planned
                        <StandardFlexBox>
                          <StandardDataField
                          :value="body_slot.work_package.time_effort_planned"
                          icon="speed"
                          width="28%"
                          :type="'number'"
                          :readonly="true"
                          />
                          <div style="width: 8%; line-height: 33px; text-align: center;">/</div>
                          <StandardDataField
                            :value="body_slot.work_package.manpower_planned"
                            icon="accessibility"
                            width="28%"
                            :type="'number'"
                            :readonly="true"
                            />
                          <div style="width: 8%; line-height: 33px; text-align: center;">=</div>
                          <StandardDataField
                            :value="body_slot.work_package.manpower_planned === 0 || isNaN(Math.round((body_slot.work_package.time_effort_planned/body_slot.work_package.manpower_planned)*100) / 100)?
                                    '':Math.round((body_slot.work_package.time_effort_planned/body_slot.work_package.manpower_planned)*100) / 100"
                            icon="timer"
                            width="28%"
                            :readonly="true"
                            />
                        </StandardFlexBox>
                        <StandardFlexBox>
                          <StandardDataField
                            :value="body_slot.work_package.quantity_value"
                            icon="drag_indicator"
                            width="33%"
                            :type="'number'"
                            :readonly="true"
                            />
                          <StandardDataField
                            :value="body_slot.work_package.quantity_unit"
                            icon="drag_indicator"
                            width="33%"
                            :readonly="true"
                            />
                        </StandardFlexBox>
                      </StandardFlexBox>
                      <!-- attributes actual -->
                      <StandardFlexBox
                        style="border-left: solid 1px black"
                        class="pa-1"
                        width="50%"
                        direction="column"
                        >
                        attributes actual
                        <StandardFlexBox>
                          <StandardDataField
                            :value="body_slot.work_package.manpower_actual === 0?
                                    '':Math.round((body_slot.work_package.duration_actual*body_slot.work_package.manpower_actual)*100) / 100"
                            icon="speed"
                            icon_actual="true"
                            width="28%"
                            :readonly="true"
                            />
                          <div style="width: 8%; line-height: 33px; text-align: center;">=</div>
                          <StandardDataField
                            :value="body_slot.work_package.manpower_actual"
                            icon="accessibility"
                            icon_actual="true"
                            width="28%"
                            :type="'number'"
                            :readonly="true"
                            />
                          <div style="width: 8%; line-height: 33px; text-align: center;">x</div>
                          <StandardDataField
                            :value="body_slot.work_package.duration_actual"
                            icon="timer"
                            icon_actual="true"
                            width="28%"
                            :type="'number'"
                            :readonly="true"
                            />
                        </StandardFlexBox>
                      </StandardFlexBox>
                    </StandardFlexBox>
                  <v-divider color="black"></v-divider>
                  <!-- Contact -->
                  <StandardFlexBox
                    direction="column"
                    :no_wrap="true"
                    >
                    contact
                    <StandardDataField
                      width="100%"
                      :value="body_slot.work_package.contact_name"
                      icon="account_circle"
                      :readonly="true"
                      />
                    <StandardDataField
                      width="100%"
                      :value="body_slot.work_package.contact_phone_number"
                      icon="call"
                      :readonly="true"
                      />
                    <StandardDataField
                      width="100%"
                      :value="body_slot.work_package.contact_email"
                      icon="email"
                      :readonly="true"
                      />
                    </StandardFlexBox>
                </template>
              </WaggonInfoBody>
            </template>
            <template v-if="show_info_box_body === 'worksteps'">
              <WaggonInfoBody
                :color="work_packages_large[work_packages_large_index].color"
                :work_package="work_packages_large[work_packages_large_index]"
                :info_box="true"
                >
                <template #body-content="body_slot">
                  WORK.steps ({{body_slot.work_package.work_steps.length}})
                  <StandardStep
                    v-for="(work_step) in body_slot.work_package.work_steps"
                    :key="'work_step' + work_step.id"
                    :step="work_step"
                    :readonly="true"
                    step_type="worksteps"
                  />
                </template>
              </WaggonInfoBody>
            </template>
            <template v-if="show_info_box_body === 'qualitysteps'">
              <WaggonInfoBody
                :color="work_packages_large[work_packages_large_index].color"
                :work_package="work_packages_large[work_packages_large_index]"
                :info_box="true"
                >
                <template #body-content="body_slot">
                  QUALITY.steps ({{body_slot.work_package.quality_steps.length}})
                  <StandardStep
                    v-for="(quality_step) in body_slot.work_package.quality_steps"
                    :key="'quality_step' + quality_step.id"
                    :step="quality_step"
                    :readonly="true"
                    step_type="qualitysteps"
                  />
                </template>
              </WaggonInfoBody>
            </template>
            <template v-if="show_info_box_body === 'defectsteps'">
              <WaggonInfoBody
                :color="work_packages_large[work_packages_large_index].color"
                :work_package="work_packages_large[work_packages_large_index]"
                :info_box="true"
                >
                <template #body-content="body_slot">
                  DEFECT.steps ({{body_slot.work_package.defect_steps.length}})
                  <StandardStep
                    v-for="(defect_step) in body_slot.work_package.defect_steps"
                    :key="'defect_step' + defect_step.id"
                    :step="defect_step"
                    :readonly="true"
                    step_type="defectsteps"
                  />
                </template>
              </WaggonInfoBody>
            </template>
            <template v-if="show_info_box_body === 'nosteps'">
              <WaggonInfoBody
                :color="work_packages_large[work_packages_large_index].color"
                :work_package="work_packages_large[work_packages_large_index]"
                :info_box="true"
                >
                <template #body-content="body_slot">
                  <StandardFlexBox
                    direction="column"
                    align_content="center"
                    justify_content="center"
                    height="calc(100% - 36px)"
                    >
                    <div
                      :class="`mb-1 ${body_slot.work_package.color}--text text--darken-3 font-weight-medium`"
                      v-if="!body_slot.work_package.work_steps ||
                          body_slot.work_package.work_steps.length === 0"
                      >
                      ... no WORK.steps created
                    </div>
                    <div
                      :class="`mb-1 ${body_slot.work_package.color}--text text--darken-3 font-weight-medium`"
                      v-if="!body_slot.work_package.quality_steps ||
                          body_slot.work_package.quality_steps.length === 0"
                      >
                      ... no QUALITY.steps created
                    </div>
                    <div
                      :class="`mb-1 ${body_slot.work_package.color}--text text--darken-3 font-weight-medium`"
                      v-if="!body_slot.work_package.defect_steps ||
                          body_slot.work_package.defect_steps.length === 0"
                      >
                      ... no DEFECT.steps created
                    </div>
                    <div
                      :class="`mb-1 ${body_slot.work_package.color}--text text--darken-3 font-weight-medium`"
                      v-if="!body_slot.work_package.handover_steps ||
                          body_slot.work_package.handover_steps.length === 0"
                      >
                      ... no Handover.steps created
                    </div>
                  </StandardFlexBox>
                </template>
              </WaggonInfoBody>
            </template>
          </template>
        </WaggonInfo>
      </template>
    </InfoBox>
    <v-row>
      <v-col cols="12" xs12>
        <v-card class="color-2 ma-4 pa-4">
          <v-row>
            <v-col cols="10" xs10>
              <StandardTextfield
                color="secondary"
                icon="search"
                textcolor="white"
                placeholder="Search for hashtags"
                :value="hashtags"
                @changeValue="hashtags = $event"
                style="width: 90%"
              />
            </v-col>
            <v-col cols="2" xs2>
              <v-btn color="secondary" @click="search({hashtags: hashtags})">
                Search
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="getCommunityWorkPackages.length === 0" align="center" justify="center">
      <v-col cols="10" align="center" justify="center">
        <v-alert type="info">
          There are no Work Packages in the community yet.
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" xs12>
        <v-card class="color-2 ma-4 pa-4">
          <v-row>
            <v-col :cols="getCols()" v-for="community_work_package in getCommunityWorkPackages" :key="community_work_package.id">
              <v-card class="color-3 pa-2">
                <v-row>
                  <v-col cols="12">
                    <WorkPackageHeaderDetails @hashtagSearchClick="search($event)" :work_package="community_work_package" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <Waggon
                    workpackage_count="1"
                    @click.native="clickWaggon([community_work_package])"
                    >
                      <template #content>
                        <v-hover>
                          <WorkPackage
                          slot-scope="{ hover }"
                          :color="community_work_package.color"
                          :icon="community_work_package.icon"
                          :token="community_work_package.token"
                          :workpackage_count="1"
                          >
                            <StandardHover v-if="hover"/>
                          </WorkPackage>
                        </v-hover>
                      </template>
                    </Waggon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="8">
                    <CommunityOwnerDetails :owner="community_work_package.owner" />
                  </v-col>
                  <v-col cols="4">
                    <StandardLikeBtn class="pull-right" :el="community_work_package" :curr_user_id="getUserId" @unlikeClick="unlikeCWorkPackage($event)" @likeClick="likeCWorkPackage($event)" />
                    <StandardDeleteBtn v-if="hasPermission('CWWorkPackage DELETE')" :el="community_work_package" btnclass="pull-right" @deleteClick="deleteCWorkPackage($event)" />
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { WorkPackageLargeMixin } from '@/mixins/WorkPackageLarge.mixin.js';
import store from '@/store/index';
import {
  mapGetters,
  mapActions
} from 'vuex';
import WorkPackageHeaderDetails from '@/components/WorkPackages/WorkPackageHeaderDetails.component.vue';
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue';
import StandardLikeBtn from '@/components/StandardComponents/StandardLikeBtn.component.vue';
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue';
import CommunityOwnerDetails from '@/components/Community/CommunityOwnerDetails.component.vue';
import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import StandardHover from '@/components/StandardComponents/StandardHover.component.vue';
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
export default {
  name: 'CommunityWorkPackages',
  components: {
    WorkPackageHeaderDetails,
    StandardTextfield,
    StandardLikeBtn,
    StandardDeleteBtn,
    CommunityOwnerDetails,
    Waggon,
    StandardHover,
    WorkPackage
  },
  mixins: [WorkPackageLargeMixin],
  data: function() {
    return {
      hashtags: '',
      waggon_large_dialog: false,
      work_packages_large: []
    }
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('Community/requestCWorkPackages').then(res => next(res));
  },
  computed: {
    ...mapGetters('Community', [
      'getCommunityWorkPackages',
      'isLoading'
    ]),
    ...mapGetters('Auth', [
      'hasPermission',
      'getUserId'
    ])
  },
  methods: {
    ...mapActions('Community', [
      'deleteCommunityWorkPackage',
      'likeCommunityWorkPackage',
      'unlikeCommunityWorkPackage',
      'requestCommunityWorkPackagesByHashtags',
      'requestCWorkPackages'
    ]),
    getCols(){
      if (this.$vuetify.breakpoint.smAndDown) {
        return 12;
      } else if(this.$vuetify.breakpoint.mdOnly) {
        return 6;
      } else {
        return 4;
      }
    },
    deleteCWorkPackage(cwork_package){
      this.deleteCommunityWorkPackage({
        cworkpackage_id: cwork_package.id
      });
    },
    unlikeCWorkPackage(cwork_package){
      this.unlikeCommunityWorkPackage({
        cworkpackage_id: cwork_package.id
      });
    },
    likeCWorkPackage(cwork_package){
      this.likeCommunityWorkPackage({
        cworkpackage_id: cwork_package.id
      });
    },
    search: function (payload) {
      this.hashtags = payload.hashtags;
      if (payload.hashtags.length) {
        this.requestCommunityWorkPackagesByHashtags(payload);
      }
      else {
        this.requestCWorkPackages();
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
